import SelectedAssetSource from 'src/services/geoJson/sources/SelectedAssetSource';
import AssetsBaseLayer from './AssetsBaseLayer';

export default class SelectedAssetLayer extends AssetsBaseLayer {
  /** @var {String} id */
  static id = 'selected-asset';

  /**
   * @returns {Object} A GeoJson layer config object.
   */
  getConfig() {
    const parentConfig = super.constructor.getConfig();

    return Object.freeze({
      id: this.getId(),
      ...parentConfig,
      source: SelectedAssetSource.id,
      layout: {
        ...parentConfig.layout,
        'icon-image': '{icon}-outline',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 3, 0.5, 17, 0.7],
      },
    });
  }
}
